import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { InputGroup, Input, Button } from "reactstrap";
import AdvancedSearch from "./AdvancedSearch";
import { toDateLocal } from "../../utils/Helper";

const AdvancedSearchbox = ({
  searchboxPlaceholder = "",
  showAdvanced = false,
  defaultOpenAdvanced = false,
  defaultFromDate,
  defaultToDate,
  onBasicFilterUpdate,
  onAdvancedFilterUpdate,
  isSearching,
}) => {
  const [isOpenAdvanced, setIsOpenAdvanced] = useState(defaultOpenAdvanced);
  const [basicFilter, setBasicFilter] = useState({
    text: "",
  });
  const [advancedFilter, setAdvancedFilter] = useState({
    fromDate: defaultFromDate,
    toDate: defaultToDate,
  });

  useEffect(() => {
    onAdvancedFilterUpdate({ isOpenAdvanced });
  }, [isOpenAdvanced]);

  const updateBasicFilterValue = (property, newValue) => {
    const newFilter = {
      ...basicFilter,
      [property]: newValue,
    };

    setBasicFilter(newFilter);
    onBasicFilterUpdate(newFilter);
  };

  const updateAdvancedFilterValue = (property, newValue) => {
    const newFilter = {
      ...advancedFilter,
      [property]: newValue,
    };

    setAdvancedFilter(newFilter);
  };

  const onSearch = () => {
    onAdvancedFilterUpdate(advancedFilter);
  };

  const toggleAdvanced = () => {
    if (isOpenAdvanced) {
      // We are closing the advanced feature.
      // We want the page to load the default values.
      onAdvancedFilterUpdate({});
    }
    setIsOpenAdvanced(!isOpenAdvanced);
  };

  return (
    <Fragment>
      <InputGroup>
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="fa fa-search" />
          </span>
        </div>

        <Input
          type="text"
          placeholder={searchboxPlaceholder}
          value={basicFilter.text}
          onChange={(e) => updateBasicFilterValue("text", e.target.value)}
        />
        {showAdvanced && !isOpenAdvanced && (
          <div className="input-group-append">
            <Button type="button" color="primary" onClick={toggleAdvanced}>
              Advanced <i className="fa fa-caret-down" />
            </Button>
          </div>
        )}
      </InputGroup>
      {showAdvanced && (
        <AdvancedSearch
          open={isOpenAdvanced}
          onChange={updateAdvancedFilterValue}
          onSearch={onSearch}
          toggleAdvancedSearch={toggleAdvanced}
          {...advancedFilter}
          isSearching={isSearching}
        />
      )}
    </Fragment>
  );
};

AdvancedSearchbox.propTypes = {
  searchboxPlaceholder: PropTypes.string,
  showAdvanced: PropTypes.bool,
  defaultOpenAdvanced: PropTypes.bool,
  defaultFromDate: PropTypes.string,
  defaultToDate: PropTypes.string,
  onBasicFilterUpdate: PropTypes.func.isRequired,
  onAdvancedFilterUpdate: PropTypes.func.isRequired,
};

AdvancedSearchbox.defaultProps = {
  searchboxPlaceholder: "",
  showAdvanced: false,
  defaultOpenAdvanced: false,
  defaultFromDate: toDateLocal(new Date()),
  defaultToDate: toDateLocal(new Date()),
};

export default AdvancedSearchbox;
